import serviceProxy from '@ServiceProxy/ServiceProxy.js'
import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const userModule = {
  state: {
    userInfo: {
      name: '',
      image: '',
      account: '',
      permission: true,
      communityId: '',
      uid: ''
    },
    userRoles: []
  },
  actions: {
    async getUserId({ commit }) {
      try {
        const res = await baseFetch(
          API.getUserInfo.url,
          API.getUserInfo.method,
        )
        if (!res.isError && res.data) {
          const data = {
            ...res.data.data
          }
          // 儲存用戶UID
          commit('SET_UID', data.uid)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得登入帳號所有角色列表及對應社區
    async getAllUserRoles({ commit }, payload) {
      // let params = // payload可指定值
      //   {
      //     parent: 'bcccfb99-8adf-4bc1-9432-950f9c750040', //社區 or 店家 or 居家編號
      //     parentType: 1 //類別 [社區: 1] [店家: 2] [居家: 3]
      //   }
      try {
        const res = await baseFetch(
          API.allUserRoles.url,
          API.allUserRoles.method,
          payload
        )
        if (!res.isError && res.data) {
          commit('SET_USER_ROLES', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  },
  mutations: {
    // 儲存登入用戶資訊
    SET_USERINFO(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        name: payload.name,
        account: payload.account,
        communityId: payload.communityId
      }
    },
    // 切換角色權限(Demo用)
    CHANGE_PERMISSION(state, payload) {
      state.userInfo = payload
    },
    async setUserinfo(state){//設定帳戶資料
      if(!localStorage.getItem('userInfo') || localStorage.getItem('userInfo') == undefined) return
      let info = JSON.parse(localStorage.getItem('userInfo'))
      state.userInfo.name = info.name
      await serviceProxy.setToken(info.token)
      serviceProxy.getApi('WebAPI/api/UserDataStore/list/' + info.account + '/Userinfo')//取得帳戶圖片
      .then(function(res){
        console.log(res)
        state.userInfo.image = res.data.image
      })      
      .catch(function(err){
        console.log(err)
      })
    },
    // renUsername(state , name){
    //   let info = JSON.parse(localStorage.getItem('userInfo'))
    //   state.userInfo = info
    // }
    SET_UID(state, payload) {
      state.userInfo.uid = payload
    },
    SET_USER_ROLES(state, payload){
      console.log('SET_USER_ROLES', payload)
      state.userRoles = payload
    }
  },
  getters: { 
    getUserInfo: (state) => state.userInfo,
    getCommunityId: (state) => state.communityId, 
    getUserRoles: (state) => state.userRoles
  },
  namespaced: true
}

export default userModule
